module.exports = __webpack_public_path__ + "media/logos/merit-logo-9e90fef0.png";